import Vue from 'vue'
import App from './App.vue'

import AOS from 'aos'
import 'aos/dist/aos.css'
import VueParallaxJs from 'vue-parallax-js'
import VueScrollTo from 'vue-scrollto'
import VueRouter from 'vue-router'
import VTooltip from 'v-tooltip'
import Home from '../src/components/Home.vue'
import About from '../src/components/About.vue'
import Skills from '../src/components/Skills.vue'
import Contact from '../src/components/Contact.vue'

var VueCookie = require('vue-cookie');

Vue.use(VTooltip)
Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(VueCookie);
Vue.use(VueParallaxJs)

Vue.config.productionTip = false

const routes = [
  { path: '', name: 'Home', component: Home},
  { path: '/ueber_mich', name: 'Über mich', component: About },
  { path: '/wahlprogramm', name: 'Wahlprogramm', component: Skills },
  { path: '/kontakt', name: 'Kontakt', component: Contact },
]

const router = new VueRouter({
  mode:'abstract',
  routes  
})

new Vue({
  created () {
    AOS.init()
  },
  router,
  render: h => h(App),
}).$mount('#app')
